import { Icon, Text } from '@cronos-labs/tectonic-ui-kit';
import get from 'lodash/get';

import { formatPercent, formatRateToPercent } from '@lib/units';
import { PARTNER_TOKEN_ICONS } from '@config/constants';

import CardValue from './CardValue';

interface BorrowSupplyCardDistributionApyProps {
  distributionApy: number | null;
  loading: boolean;
  symbol?: string;
}

function BorrowSupplyCardDistributionApy({
  distributionApy,
  loading,
  symbol,
}: BorrowSupplyCardDistributionApyProps): JSX.Element {
  const PartnerIcon = get(PARTNER_TOKEN_ICONS, symbol ?? '', Icon.Tonic);
  return (
    <div className="space-y-1">
      <div className="flex items-center space-x-0.5">
        <PartnerIcon />
        <Text className="text-small">Distribution APY</Text>
      </div>
      <CardValue
        loading={loading}
        value={
          distributionApy !== null && (
            <Text className="text-large">
              {formatPercent(formatRateToPercent(distributionApy))}
            </Text>
          )
        }
      />
    </div>
  );
}

export default BorrowSupplyCardDistributionApy;
